export default "__VITE_ASSET__FXiR9jeR__"